/**
 * @file contains helper functions for AttachmentRemove component
 */
import { ButtonOwnProps } from '@mui/material';

import { AttachmentMode } from '../../../../models/attachment';
import { MuiIconName } from '../../../MUI/MuiIcon/types';

/**
 * Get icon name for the attachment remove button
 *
 * @param mode Current attachment mode
 * @returns    Icon name
 */
export const getButtonIcon = (mode: AttachmentMode): MuiIconName => {
  return mode === 'detailsEdit' ? 'deleteOutlined' : 'close';
};

/**
 * Get color for the attachment remove button
 *
 * @param mode Current attachment mode
 * @returns    Color of the button
 */
export const getButtonColor = (
  mode: AttachmentMode,
): ButtonOwnProps['color'] => {
  return mode === 'detailsEdit' ? 'error' : undefined;
};
